/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Type guards and validation for saved views.
 */

import type { InputSavedView, NormalizedSavedView } from "./types";

export function isValidNormalizedSavedView<TFilters = Record<string, unknown>>(
  view: unknown,
): view is NormalizedSavedView<TFilters> {
  if (!view || typeof view !== "object") {
    return false;
  }

  const v = view as Partial<NormalizedSavedView<TFilters>>;

  if (!v.id || typeof v.id !== "string" || v.id.trim().length === 0) {
    return false;
  }

  if (!v.name || typeof v.name !== "string" || v.name.trim().length === 0) {
    return false;
  }

  if (v.filters === undefined || v.filters === null) {
    return false;
  }

  return true;
}

export function hasValidSavedViewId<TFilters = unknown>(
  view: InputSavedView<TFilters>,
): boolean {
  const viewId = view.view_id ?? view.id;

  if (!viewId || typeof viewId !== "string" || viewId.trim().length === 0) {
    return false;
  }

  return true;
}
